import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, waLink } from "@/lib/site-utils";
import { FLEET } from "@/data/site";

export const Fleet = () => {
  return (
    <section id="fleet" data-testid="fleet-section" className="relative border-t border-white/10 py-24 md:py-36">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6"
        >
          <div>
            <span className="font-plex text-xs tracking-[0.25em] uppercase text-jcb">हमारा बेड़ा / OUR FLEET</span>
            <h2 className="mt-4 font-khand font-700 uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl text-[#f5f5f0]">
              मशीनें व गाड़ियाँ
            </h2>
          </div>
          <p className="max-w-sm font-hind text-neutral-400">
            असली फोटो, दमदार मशीनें और आरामदायक गाड़ियाँ — हर काम और हर सफर के लिए तैयार।
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 auto-rows-[260px] gap-4 md:gap-6">
          {FLEET.map((f, i) => {
            const accentText = f.accent === "jcb" ? "text-jcb" : "text-terra";
            const accentBg = f.accent === "jcb" ? "bg-jcb" : "bg-terra";
            return (
              <motion.div
                key={f.id}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                className={`group relative overflow-hidden border border-white/10 ${f.span}`}
                data-testid={`fleet-card-${f.id}`}
              >
                <img src={f.img} alt={f.nameEn} className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-asphalt via-asphalt/50 to-asphalt/10" />
                <span className={`absolute top-4 left-4 ${accentBg} text-black font-plex text-[10px] tracking-[0.2em] uppercase px-3 py-1`}>
                  {f.tag}
                </span>
                <div className="absolute bottom-0 inset-x-0 p-6 flex items-end justify-between">
                  <div>
                    <h3 className="font-khand font-700 text-3xl md:text-4xl leading-none text-[#f5f5f0]">{f.name}</h3>
                    <p className={`font-plex text-xs tracking-wide mt-1 ${accentText}`}>{f.nameEn}</p>
                    <p className="font-hind text-neutral-300 text-sm mt-1">{f.meta}</p>
                  </div>
                  <a
                    data-testid={`fleet-book-${f.id}`}
                    href={waLink(`नमस्ते! मुझे ${f.name} बुक करनी है।`)}
                    target="_blank"
                    rel="noreferrer"
                    className="shrink-0 grid place-items-center h-12 w-12 bg-white/10 backdrop-blur border border-white/20 text-white hover:bg-jcb hover:text-black transition-colors duration-200"
                    aria-label={`Book ${f.name}`}
                  >
                    <ArrowUpRight size={20} />
                  </a>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
